import React, { useEffect } from 'react';
import { LoggerModule } from '@vlinder-web/logger-module-react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';
import toast from 'react-hot-toast';

export let resubmitApplicationByApplicantPageMachine: any;

const MODULE_NAME = 'machines.pageContent';
const log: any = LoggerModule?.getInstance();

export const useSMresubmitApplicationByApplicantPage = (_context: any) => {
  // toast.success('came in machine');
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  resubmitApplicationByApplicantPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(resubmitApplicationByApplicantPageMachine);

  return {
    resubmitApplicationByApplicantPageMachine,
    resubmitApplicationByApplicantPageState: state,
    resubmitApplicationByApplicantPageSend: send,
  };
};
